/* ----------------- Start Document ----------------- */
(function () {
  "use strict";

  $(document).ready(function () {
    /*--------------------------------------------------*/
    /*  Mobile Menu - mmenu.js
	/*--------------------------------------------------*/
    $(function () {
      function mmenuInit() {
        var wi = $(window).width();
        if (wi <= "1099") {
          $(".mmenu-init").remove();
          $("#navigation")
            .clone()
            .addClass("mmenu-init")
            .insertBefore("#navigation")
            .removeAttr("id")
            .removeClass("style-1 style-2")
            .find("ul, div")
            .removeClass(
              "style-1 style-2 mega-menu mega-menu-content mega-menu-section"
            )
            .removeAttr("id");
          $(".mmenu-init").find("ul").addClass("mm-listview");
          $(".mmenu-init").find(".mobile-styles .mm-listview").unwrap();

          $(".mmenu-init").mmenu(
            {
              counters: true,
            },
            {
              // configuration
              offCanvas: {
                pageNodetype: "#wrapper",
              },
            }
          );

          var mmenuAPI = $(".mmenu-init").data("mmenu");
          var $icon = $(".mmenu-trigger .hamburger");

          $(".mmenu-trigger").on("click", function () {
            mmenuAPI.open();
          });
        }
        $(".mm-next").addClass("mm-fullsubopen");
      }
      mmenuInit();
      $(window).resize(function () {
        mmenuInit();
      });
    });

    /*----------------------------------------------------*/
    /*  Back to Top
	/*----------------------------------------------------*/

    // Button
    function backToTop() {
      $("body").append('<div id="backtotop"><a href="#"></a></div>');
    }
    backToTop();

    // Showing Button
    var pxShow = 600; // height on which the button will show
    var scrollSpeed = 500; // how slow / fast you want the button to scroll to top.

    $(window).scroll(function () {
      if ($(window).scrollTop() >= pxShow) {
        $("#backtotop").addClass("visible");
      } else {
        $("#backtotop").removeClass("visible");
      }
    });

    $("#backtotop a").on("click", function () {
      $("html, body").animate({ scrollTop: 0 }, scrollSpeed);
      return false;
    });

    /*--------------------------------------------------*/
    /*  Ripple Effect
	/*--------------------------------------------------*/
    $(".ripple-effect, .ripple-effect-dark").on("click", function (e) {
      var rippleDiv = $('<span class="ripple-overlay">'),
        rippleOffset = $(this).offset(),
        rippleY = e.pageY - rippleOffset.top,
        rippleX = e.pageX - rippleOffset.left;

      rippleDiv
        .css({
          top: rippleY - rippleDiv.height() / 2,
          left: rippleX - rippleDiv.width() / 2,
          // background: $(this).data("ripple-color");
        })
        .appendTo($(this));

      window.setTimeout(function () {
        rippleDiv.remove();
      }, 800);
    });

    /*--------------------------------------------------*/
    /*  Tippy JS 
	/*--------------------------------------------------*/
    /* global tippy */
    tippy("[data-tippy-placement]", {
      delay: 100,
      arrow: true,
      arrowType: "sharp",
      size: "regular",
      duration: 200,

      // 'shift-toward', 'fade', 'scale', 'perspective'
      animation: "shift-away",

      animateFill: true,
      theme: "dark",

      // How far the tooltip is from its reference element in pixels
      distance: 10,
    });

    /*----------------------------------------------------*/
    /*  Inline CSS replacement for backgrounds
	/*----------------------------------------------------*/
    function inlineBG() {
      // Common Inline CSS
      $(".single-page-header, .intro-banner").each(function () {
        var attrImageBG = $(this).attr("data-background-image");

        if (attrImageBG !== undefined) {
          $(this).append('<div class="background-image-container"></div>');
          $(".background-image-container").css(
            "background-image",
            "url(" + attrImageBG + ")"
          );
        }
      });
    }
    inlineBG();

    /*----------------------------------------------------*/
    /*  Share URL and Buttons
	/*----------------------------------------------------*/
    /* global ClipboardJS */
    $(".copy-url input").val(window.location.href);
    new ClipboardJS(".copy-url-button");

    $(".share-buttons-icons a").each(function () {
      var buttonBG = $(this).attr("data-button-color");
      if (buttonBG !== undefined) {
        $(this).css("background-color", buttonBG);
      }
    });

    $("#facebook-share-btn").on("click", function (e) {
      e.preventDefault();
      window.open(
        "http://facebook.com/sharer/sharer.php?u=" +
          encodeURIComponent(window.location.href),
        "",
        "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
      );
    });

    $("#twitter-share-btn").on("click", function (e) {
      e.preventDefault();
      window.open(
        "http://twitter.com/share?url=" +
          encodeURIComponent(window.location.href),
        "",
        "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
      );
    });

    $("#gplus-share-btn").on("click", function (e) {
      e.preventDefault();
      window.open(
        "https://plus.google.com/share?url=" +
          encodeURIComponent(window.location.href),
        "",
        "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
      );
    });

    $("#linkedin-share-btn").on("click", function (e) {
      e.preventDefault();
      window.open(
        "https://www.linkedin.com/sharing/share-offsite/?url=" +
          encodeURIComponent(window.location.href),
        "",
        "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
      );
    });

    /*----------------------------------------------------*/
    /*  Tabs
	/*----------------------------------------------------*/
    var $tabsNav = $(".popup-tabs-nav"),
      $tabsNavLis = $tabsNav.children("li");

    $tabsNav.each(function () {
      var $this = $(this);

      $this
        .next()
        .children(".popup-tab-content")
        .stop(true, true)
        .hide()
        .first()
        .show();
      $this.children("li").first().addClass("active").stop(true, true).show();
    });

    $tabsNavLis.on("click", function (e) {
      var $this = $(this);

      $this.siblings().removeClass("active").end().addClass("active");

      $this
        .parent()
        .next()
        .children(".popup-tab-content")
        .stop(true, true)
        .hide()
        .siblings($this.find("a").attr("href"))
        .fadeIn();

      e.preventDefault();
    });

    var hash = window.location.hash;
    var anchor = $('.tabs-nav a[href="' + hash + '"]');
    if (anchor.length === 0) {
      $(".popup-tabs-nav li:first").addClass("active").show(); //Activate first tab
      $(".popup-tab-content:first").show(); //Show first tab content
    } else {
      anchor.parent("li").click();
    }

    // Link to Register Tab
    $(".register-tab").on("click", function (event) {
      event.preventDefault();
      $(".popup-tab-content").hide();
      $("#register.popup-tab-content").show();
      $("body")
        .find('.popup-tabs-nav a[href="#register"]')
        .parent("li")
        .click();
    });

    // Disable tabs if there's only one tab
    $(".popup-tabs-nav").each(function () {
      var listCount = $(this).find("li").length;
      if (listCount < 2) {
        $(this).css({
          "pointer-events": "none",
        });
      }
    });

    /*----------------------------------------------------*/
    /*  Indicator Bar
    /*----------------------------------------------------*/
    $(".indicator-bar").each(function () {
      var indicatorLenght = $(this).attr("data-indicator-percentage");
      $(this)
        .find("span")
        .css({
          width: indicatorLenght + "%",
        });
    });

    /*----------------------------------------------------*/
    /*  Magnific Popup
    /*----------------------------------------------------*/

    $.magnificPopup.instance.close = function (e) {
      if (this.st.el[0].id === "sticky-apply-button" && e === undefined) {
        openJob();
      }
      $.magnificPopup.proto.close.call(this);
    };

    // $(".apply-now-button").magnificPopup({
    //   type: "inline",
    //   fixedContentPos: false,
    //   fixedBgPos: true,
    //   overflowY: "auto",
    //   closeBtnInside: true,
    //   preloader: false,
    //   midClick: true,
    //   removalDelay: 300,
    //   mainClass: "my-mfp-zoom-in",
    // callbacks: {
    //    open: function() {
    // 		var popSenseAd = '<div><p style="font-weight: 500; font-size: 11px; margin-bottom: 0; text-align: center">Advertisement</p><ins class=" adsbygoogle" style="display: inline-block; width: 250px; height: 250px;" data-ad-client="ca-pub-4285154668933358" data-ad-slot="7623721769" data-ad-layout="" data-ad-layout-key="" data-ad-format="" data-full-width-responsive="false"></ins></div>';
    // 		$("#popSenseAd").html(popSenseAd);
    // 		if(window) (window.adsbygoogle = window.adsbygoogle || []).push({});
    //    },
    //    close: function() {
    //      $("#popSenseAd").html("");
    //    }
    //  }
    // });

    // $(".report-listing-link").magnificPopup({
    //   type: "inline",
    //   fixedContentPos: false,
    //   fixedBgPos: true,
    //   overflowY: "auto",
    //   closeBtnInside: true,
    //   preloader: false,
    //   midClick: true,
    //   removalDelay: 300,
    //   mainClass: "my-mfp-zoom-in",
    //   callbacks: {
    //     open: function () {
    //       $("#report-listing-url").val(window.location.pathname.split("/")[2]);
    //     },
    //   },
    // });

    // $(".create-job-alert").on("click", function (e) {
    //   e.preventDefault();
    //   if ($("#apply-now-form")[0].checkValidity()) {
    //     var $this = $(this);
    //     $this.attr("disabled", "disabled").html("Subscribing ...");
    //     $.post("/alerts", $("#apply-now-form").serialize(), function (data) {
    //       var btnText =
    //         "Subscribed <i class='icon-material-outline-check-circle'></i>";
    //       if (data.status === "failed")
    //         btnText =
    //           "Failed <i class='icon-material-outline-highlight-off'></i>";
    //       $this.html(btnText);
    //       $.magnificPopup.instance.close("subnApply");
    //       Snackbar.show({
    //         pos: "top-right",
    //         duration: null,
    //         actionTextColor: "#2a41e8",
    //         text: data.message,
    //       });
    //     });
    //     if ($this[0].id === "subscribe-and-apply") openJob();
    //   } else {
    //     $("#apply-now-form")[0].reportValidity();
    //   }
    // });

    // $(".report-listing-btn").on("click", function (e) {
    //   e.preventDefault();
    //   $("#report-listing-url").val(window.location.pathname.split("/")[2]);
    //   if ($("#report-listing-form")[0].checkValidity()) {
    //     var $this = $(this);
    //     $this.attr("disabled", "disabled").html("Reporting ...");
    //     $.post(
    //       "/report_listing",
    //       $("#report-listing-form").serialize(),
    //       function (data) {
    //         var btnText =
    //           "Reported <i class='icon-material-outline-check-circle'></i>";
    //         if (data.status === "failed")
    //           btnText =
    //             "Failed <i class='icon-material-outline-highlight-off'></i>";
    //         $this.html(btnText);
    //         $.magnificPopup.instance.close("reportListing");
    //         Snackbar.show({
    //           pos: "top-right",
    //           duration: null,
    //           actionTextColor: "#2a41e8",
    //           text: data.message,
    //         });
    //       }
    //     );
    //   } else {
    //     $("#report-listing-form")[0].reportValidity();
    //   }
    // });

    // function openJob() {
    //   var url = window.location.pathname + "/apply";
    //   window.open(url, "_blank");
    // }

    var stickyWaypointElem = document.getElementById("stickyWaypoint");
    if (stickyWaypointElem !== null) {
      var stickyWaypoint = new Waypoint({
        element: document.getElementById("stickyWaypoint"),
        offset: "bottom-in-view",
        handler: function (direction) {
          if (direction === "down") {
            $("#sticky-apply-button").removeClass("is-sticky");
          } else {
            $("#sticky-apply-button").addClass("is-sticky");
          }
        },
      });
    }

    // ------------------ End Document ------------------ //
  });
})(this.jQuery);
